import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const root = createRoot(document.getElementById('root')!);
root.render(<App data-id="element-160" />);